export const SuccessCard = ({ title, description }) => {
  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center w-full"
      style={{
        backgroundColor: "rgba(0, 112, 204, 0.3)",
        border: "1px solid rgba(0, 112, 204, 0.5)",
        borderRadius: "20px",
        padding: "16px",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
      }}
    >
      <h1
        style={{
          fontSize: "14px",
          fontWeight: 700,
          color: "#E6ECF1",
          margin: 0,
          marginBottom: "8px",
          textAlign: "center",
        }}
        className="success-card-title"
      >
        {title}
      </h1>
      <p
        style={{
          fontSize: "16px",
          fontWeight: 400,
          color: "#B5BBC0",
          margin: 0,
          textAlign: "center",
        }}
        className="success-card-description"
      >
        {description}
      </p>
    </div>
  );
};
